import { DomainCryptoRequestDto, } from '@lucidlink/dto/web-service-api';
import { AES_ENCRYPTION_ALGO_PARAMS, aesKeyToArray, arrayToBase64, cryptoKeyToBase64, decryptAesKeyWithPrivateKey, encryptCryptoKeyWithAes, encryptCryptoKeyWithPublicKey, generateAesGcmKey, InvalidCryptoKeyError, shaDigest, stringToCryptoKey, } from '@lucidlink/ts-crypto/crypto';
export const prepareDomainCryptoForCreate = async ({ adminKeys, ssoSecretKey, }) => {
    const domainCryptoKey = await generateAesGcmKey();
    return createDomainCryptoDto({ domainCryptoKey, adminKeys, ssoSecretKey });
};
export const prepareDomainCryptoForExport = async ({ adminKeys, domainCryptoData, }) => {
    const domainKey = await decryptAesKeyWithPrivateKey(domainCryptoData.eDomainKeyByAdminKey, adminKeys.encryptPair.privateKey);
    return cryptoKeyToBase64(domainKey);
};
export const prepareDomainCryptoForImport = async ({ adminKeys, domainKey, ssoSecretKey, }) => {
    const domainCryptoKey = await stringToCryptoKey(domainKey, AES_ENCRYPTION_ALGO_PARAMS).catch(() => {
        throw new InvalidCryptoKeyError();
    });
    return createDomainCryptoDto({ domainCryptoKey, adminKeys, ssoSecretKey });
};
const computeDomainHash = async (domainKey) => {
    const domainKeyBuffer = await aesKeyToArray(domainKey);
    const domainHashBuffer = await shaDigest(domainKeyBuffer, 'SHA-256');
    return arrayToBase64(domainHashBuffer);
};
export const createDomainCryptoDto = async (params) => {
    const eDomainKeyByAdminKey = await encryptCryptoKeyWithPublicKey(params.domainCryptoKey, params.adminKeys.encryptPair.publicKey);
    const eSsoSecretByDomainKey = await encryptCryptoKeyWithAes(params.ssoSecretKey, params.domainCryptoKey);
    const domainHash = await computeDomainHash(params.domainCryptoKey);
    return DomainCryptoRequestDto.create({
        eDomainKeyByAdminKey,
        eSsoSecretByDomainKey,
        domainHash,
    });
};
